/* 1.4: match real option values in the current section; no asynchronous price requests. */
(() => {
  if (window.mcSizePrices) return;
  const cache = new WeakMap();
  const sizeKey = value => String(value).toLowerCase().replace(/×/g, 'x').replace(/\s+/g, '');
  function update(picker) {
    if (!picker.isConnected || picker.closest('[hidden]') || picker.style.display === 'none') return;
    const node = picker.querySelector('[data-mc-size-variants]');
    if (!node) return;
    let data = cache.get(node);
    if (!data) { try { data = JSON.parse(node.textContent); cache.set(node, data); } catch { return; } }
    const sizeIndex = data.options.findIndex(name => name.toLowerCase() === 'size');
    if (sizeIndex < 0) return;
    const groups = [...picker.querySelectorAll('[data-mc-option-position]')];
    const selections = data.options.map((_, i) => {
      const group = groups.find(el => Number(el.dataset.mcOptionPosition) === i + 1);
      return group?.querySelector('input:checked, select')?.value;
    });
    const sizes = groups.find(el => Number(el.dataset.mcOptionPosition) === sizeIndex + 1);
    sizes?.querySelectorAll('input[type="radio"]').forEach(input => {
      const price = input.nextElementSibling?.querySelector('[data-mc-size-price]');
      if (!price) return;
      const variant = data.variants.find(v => v.options.every((value, i) =>
        i === sizeIndex ? sizeKey(value) === sizeKey(input.value) : value === selections[i]));
      const available = variant?.available === true;
      const text = available ? variant.money : '';
      if (price.textContent !== text) price.textContent = text;
      price.hidden = !available;
      input.classList.toggle('disabled', !available);
      if (available) price.dataset.variantId = String(variant.id);
      else delete price.dataset.variantId;
    });
  }
  window.mcSizePrices = { update, refresh() { document.querySelectorAll('product-info variant-selects').forEach(update); } };
})();
